var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 100.0 119.06299212598425",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l100.0 0l0 119.062996l-100.0 0l0 -119.062996z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l100.0 0l0 119.062996l-100.0 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d9d9d9",
    d: "m10.692913 14.980577l0 0c0 -7.23638 5.8662453 -13.102625 13.102625 -13.102625l52.40892 0l0 0c3.4750366 0 6.8077393 1.380451 9.264954 3.8376696c2.457222 2.4572186 3.8376694 5.789922 3.8376694 9.2649555l0 89.10184c0 7.2363815 -5.8662415 13.102623 -13.102623 13.102623l-52.40892 0c-7.2363796 0 -13.102625 -5.8662415 -13.102625 -13.102623z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m10.692913 14.980577l0 0c0 -7.23638 5.8662453 -13.102625 13.102625 -13.102625l52.40892 0l0 0c3.4750366 0 6.8077393 1.380451 9.264954 3.8376696c2.457222 2.4572186 3.8376694 5.789922 3.8376694 9.2649555l0 89.10184c0 7.2363815 -5.8662415 13.102623 -13.102623 13.102623l-52.40892 0c-7.2363796 0 -13.102625 -5.8662415 -13.102625 -13.102623z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    d: "m46.0 22.485565l4.0 -7.1338587l4.0 7.1338587l-4.0 7.1338577z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m46.0 22.485565l4.0 -7.1338587l4.0 7.1338587l-4.0 7.1338577z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    d: "m46.0 59.53281l4.0 -7.1338615l4.0 7.1338615l-4.0 7.133854z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m46.0 59.53281l4.0 -7.1338615l4.0 7.1338615l-4.0 7.133854z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    d: "m46.0 94.632545l4.0 -7.1338577l4.0 7.1338577l-4.0 7.1338577z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m46.0 94.632545l4.0 -7.1338577l4.0 7.1338577l-4.0 7.1338577z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    d: "m78.29396 91.62467l1.5118103 -2.6929169l1.5118179 2.6929169l-1.5118179 2.6929169z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m78.29396 91.62467l1.5118103 -2.6929169l1.5118179 2.6929169l-1.5118179 2.6929169z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    d: "m18.0 25.847769l1.5118103 -2.692913l1.5118122 2.692913l-1.5118122 2.692913z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m18.0 25.847769l1.5118103 -2.692913l1.5118122 2.692913l-1.5118122 2.692913z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m7.3708973 0.06824147l22.393702 0l0 32.31496l-22.393702 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m19.152147 19.46449q-0.90625 0 -1.421875 -0.328125q-0.515625 -0.34375 -0.734375 -0.953125q-0.21875 -0.625 -0.21875 -1.421875l0 -0.3125l1.78125 0q0 0.015625 0 0.125q0 0.109375 0 0.1875q0 0.421875 0.046875 0.6875q0.0625 0.265625 0.1875 0.390625q0.140625 0.125 0.390625 0.125q0.25 0 0.359375 -0.125q0.125 -0.125 0.171875 -0.375q0.046875 -0.265625 0.046875 -0.65625q0 -0.640625 -0.1875 -0.96875q-0.171875 -0.328125 -0.71875 -0.34375q-0.015625 0 -0.125 0q-0.09375 0 -0.203125 0l0 -1.234375q0.078125 0 0.140625 0q0.078125 0 0.140625 0q0.5625 0 0.75 -0.296875q0.203125 -0.3125 0.203125 -0.96875q0 -0.5 -0.140625 -0.765625q-0.125 -0.265625 -0.484375 -0.265625q-0.359375 0 -0.46875 0.296875q-0.109375 0.296875 -0.109375 0.765625q0 0.109375 0 0.21875q0 0.109375 0 0.234375l-1.78125 0l0 -0.515625q0 -0.78125 0.28125 -1.3125q0.28125 -0.546875 0.8125 -0.828125q0.53125 -0.28125 1.265625 -0.28125q0.734375 0 1.265625 0.265625q0.546875 0.265625 0.828125 0.796875q0.28125 0.515625 0.28125 1.28125q0 0.75 -0.3125 1.265625q-0.296875 0.515625 -0.734375 0.625q0.296875 0.109375 0.53125 0.34375q0.25 0.234375 0.375 0.640625q0.140625 0.390625 0.140625 1.015625q0 0.78125 -0.234375 1.390625q-0.21875 0.609375 -0.75 0.953125q-0.515625 0.34375 -1.375 0.34375z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m92.57006 117.46372l-22.3937 0l0 -32.314964l22.3937 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m80.78881 98.06747q0.90625 0 1.421875 0.328125q0.515625 0.34375 0.734375 0.953125q0.21875 0.625 0.21875 1.421875l0 0.3125l-1.78125 0q0 -0.015625 0 -0.125q0 -0.109375 0 -0.1875q0 -0.421875 -0.046875 -0.6875q-0.0625 -0.265625 -0.1875 -0.390625q-0.140625 -0.125 -0.390625 -0.125q-0.25 0 -0.359375 0.125q-0.125 0.125 -0.171875 0.375q-0.046875 0.265625 -0.046875 0.65625q0 0.640625 0.1875 0.96875q0.171875 0.328125 0.71875 0.34375q0.015625 0 0.125 0q0.09375 0 0.203125 0l0 1.234375q-0.078125 0 -0.140625 0q-0.078125 0 -0.140625 0q-0.5625 0 -0.75 0.296875q-0.203125 0.3125 -0.203125 0.96875q0 0.5 0.140625 0.765625q0.125 0.265625 0.484375 0.265625q0.359375 0 0.46875 -0.296875q0.109375 -0.296875 0.109375 -0.765625q0 -0.109375 0 -0.21875q0 -0.109375 0 -0.234375l1.78125 0l0 0.515625q0 0.78125 -0.28125 1.3125q-0.28125 0.546875 -0.8125 0.828125q-0.53125 0.28125 -1.265625 0.28125q-0.734375 0 -1.265625 -0.265625q-0.546875 -0.265625 -0.828125 -0.796875q-0.28125 -0.515625 -0.28125 -1.28125q0 -0.75 0.3125 -1.265625q0.296875 -0.515625 0.734375 -0.625q-0.296875 -0.109375 -0.53125 -0.34375q-0.25 -0.234375 -0.375 -0.640625q-0.140625 -0.390625 -0.140625 -1.015625q0 -0.78125 0.234375 -1.390625q0.21875 -0.609375 0.75 -0.953125q0.515625 -0.34375 1.375 -0.34375z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThree);
export default __webpack_public_path__ + "static/media/Three.5f71a235ab773cc7d0cb6ee1879f6f66.svg";
export { ForwardRef as ReactComponent };